import constants from 'common/constants'

import {ONBOARDING_AI_ALLOCATION} from './ActionTypes/ApiActionTypes'

export const requestOnboardingAiAllocation = (body, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_AI_ALLOCATION,
    payload: {
      apiUrl: constants.api_onboarding_ai_allocation,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
